var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({class:_setup.rootClass},_vm.$listeners),[_c(require(`./images/${_vm.icon}.vue.svg`),{tag:"component",staticClass:"portfolio-button__icon",attrs:{"alt":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }